module.exports = "./img/acc7bc069b831e3fb751f92fa5a976d5.jpg";